import ApplicationSerializer from './application';

export default class CompanyConfigurationSerializer extends ApplicationSerializer {
  serialize(object) {
    const result = super.serialize(object);
    if (result.data.relationships.company) {
      delete result.data.relationships.company;
    }
    return result;
  }
}
